import {useClearRefinements,type UseClearRefinementsProps} from "react-instantsearch";
import {useConfigContext} from "@/ConfigProvider";

export default function ResetFilters(props: UseClearRefinementsProps) {
    const {refine, canRefine} = useClearRefinements(props);
    const {tc} = useConfigContext();
    return (
        <>
            {
                canRefine &&
                    <button className={"link--underlined button--default reset--filters"} disabled={!canRefine} onClick={refine}>
                        <span>{tc.algoliaResetFilters}</span>
                        <i className={"icon icon-close"} aria-hidden={"true"}></i>
                    </button>
            }
        </>
    );
}